import dataService from "../../api";

// The organisation the system is delivered to: its name, the body it belongs to, contact details
// and logo. It is edited in Management (الإعدادات ▸ بيانات المؤسسة) and read-only here. Loaded once
// when the app starts (App.vue), before sign-in, and used by the login page, the header, the
// footer and the browser tab.
//
// Fields (camelCase from Models/OrganizationProfile.OrganizationInfo):
//   nameAr, nameEn, parentNameAr, parentNameEn, addressAr, addressEn, phone, email, website,
//   hasLogo, logoVersion
const EMPTY = {
    nameAr: "",
    nameEn: null,
    parentNameAr: null,
    parentNameEn: null,
    addressAr: null,
    addressEn: null,
    phone: null,
    email: null,
    website: null,
    hasLogo: false,
    logoVersion: null,
};

// Shown where the organisation name goes until one is entered.
export const DEFAULT_PORTAL_NAME = "منصة الموظفين";

const state = {
    org: { ...EMPTY },
    loaded: false,
};

const getters = {
    // The organisation name, or the generic portal name while none is set.
    displayName: state => state.org.nameAr || DEFAULT_PORTAL_NAME,
    // The logo URL with its version, so a new upload is not served from the browser cache; null without a logo.
    logoUrl: state => (state.org.hasLogo
        ? `/api/organization/logo?v=${encodeURIComponent(state.org.logoVersion || "0")}`
        : null),
};

const mutations = {
    setOrg: (state, org) => {
        state.org = { ...EMPTY, ...(org || {}) };
        state.loaded = true;
    },
};

const actions = {
    // Silent: a failure leaves the defaults (generic name, no logo) rather than an error on the login page.
    async load({ commit }) {
        try {
            const response = await dataService.organization.get();
            commit("setOrg", response.data.statusCode ? response.data.organization : null);
        } catch (error) {
            commit("setOrg", null);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
